import { token } from "./token.js";
import { makeInternalTokens } from "./makeInternalTokens.js";
const {
  internalTokens,
  declareTokens
} = makeInternalTokens({
  lightTheme: {
    "tabs-background-color": token.gray50a,
    "tabs-contained-tab-background-color-active": token.white,
    "tabs-tab-color": token.gray600,
    "tabs-tab-color-active": token.gray800
  },
  darkTheme: {
    "tabs-background-color": token.gray10,
    "tabs-contained-tab-background-color-active": token.gray100,
    "tabs-tab-color": token.gray600a,
    "tabs-tab-color-active": token.gray1000
  }
});
export {
  declareTokens,
  internalTokens
};
//# sourceMappingURL=themes.js.map
